module.exports = __webpack_public_path__ + "img/icon-member-setting.476ec7ac.png";